<template>
  <div>
    <el-form size="mini" :inline="true" :model="solutionForm" ref="searchForm" class="demo-form-inline">
      <el-form-item label="用水量">
        <el-input size="mini" v-model.number="solutionForm.countWaterConsumption" placeholder="用水量" clearable>
             <span slot="append">
                  {{ solutionForm.unit }}
             </span>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-search" @click="onSubmit">用量计算</el-button>
      </el-form-item>
    </el-form>
    <div v-if="cropSolutionProductSkuVoList && cropSolutionProductSkuVoList.length">
      <div>推荐购买：</div>
      <div class="m-v-10">
        <el-table border size="mini" :data="cropSolutionProductSkuVoList">
          <el-table-column prop="productName" label="产品" show-overflow-tooltip min-width="100">
          </el-table-column>
          <el-table-column label="产品规格" prop="productAttr" align="center" width="120px" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.productAttr }}
            </template>
          </el-table-column>
          <el-table-column label="稀释倍数" prop="dilutionRatio" align="center" width="90px">
            <template slot-scope="scope">
              {{ scope.row.dilutionRatio }}
            </template>
          </el-table-column>
<!--          <el-table-column label="亩用药量" prop="singleUsage" align="center" width="110px">-->
<!--            <template slot-scope="scope">-->
<!--              {{ scope.row.singleUsage }}<span v-if="scope.row.unit">{{ scope.row.unit }}/亩</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="方案用量" prop="allUsage" align="center" width="110px">
            <template slot-scope="scope">
              {{ scope.row.allUsage }}<span v-if="scope.row.unit">{{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="产品单价" prop="productPrice" align="center" width="90px">
            <template slot-scope="scope">
              {{ scope.row.productPrice }}
            </template>
          </el-table-column>
          <el-table-column label="购买数量" prop="totalNum" align="center" width="90px">
            <template slot-scope="scope">
              {{ scope.row.totalNum }}
            </template>
          </el-table-column>
          <!--            <el-table-column label="产品用量(公斤)" prop="realUsage" align="center" width="110px">-->
          <!--              <template slot-scope="scope">-->
          <!--                {{ scope.row.realUsage }}-->
          <!--              </template>-->
          <!--            </el-table-column>-->
          <el-table-column label="产品总价" prop="productMoney" align="center" width="100px">
            <template slot-scope="scope">
              {{ scope.row.productMoney }}
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
import CropSolutionApi from '@/api/cropsolution.js'

export default {
  name: 'CalculateUsage',
  props: ['solutionForm'],
  data () {
    return {
      cropSolutionProductSkuVoList: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onSubmit () {
      console.log('this.solutionForm', this.solutionForm)
      CropSolutionApi.getCountResult(this.solutionForm, true).then(res => {
        this.cropSolutionProductSkuVoList = res.data.cropSolutionProductSkuVoList || []
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/crop/solution/period/component/CalculateUsage.vue